/* eslint-disable react/prop-types */
import { useEffect, useState } from 'react'
import { formatTimer } from '../utils/formatTimer'
import styles from './styles.module.css'

export const OfferBox = ({
  variant = 'solid',
  label,
  couponText,
  couponCode,
  couponValidityText = ' · válido só na 1ª compra',
  price,
  originalPrice,
  description,
  subdescription,
  unitPrice,
  timerSeconds,
  timerLabel = 'a oferta expira em',
  onTimerExpire,
}) => {
  const [remaining, setRemaining] = useState(timerSeconds)

  useEffect(() => {
    if (timerSeconds == null) return undefined

    setRemaining(timerSeconds)

    const interval = setInterval(() => {
      setRemaining((current) => {
        if (current <= 1) {
          clearInterval(interval)
          onTimerExpire?.()
          return 0
        }
        return current - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [timerSeconds, onTimerExpire])

  const variantClass =
    variant === 'dashed' ? styles.offerBoxDashed : styles.offerBoxSolid

  return (
    <div className={`${styles.offerBox} ${variantClass}`}>
      {label && <p className={styles.offerLabel}>{label}</p>}
      {couponCode ? (
        <p className={styles.offerCoupon}>
          <span className={styles.offerCouponMuted}>Cupom </span>
          <span className={styles.offerCouponCode}>{couponCode}</span>
          <span className={styles.offerCouponMuted}>{couponValidityText}</span>
        </p>
      ) : (
        couponText && (
          <p className={`${styles.offerCoupon} ${styles.offerCouponPlain}`}>
            {couponText}
          </p>
        )
      )}
      <div className={styles.offerPriceRow}>
        {originalPrice != null && (
          <p className={styles.offerOriginalPrice}>{originalPrice}</p>
        )}
        {price != null && <p className={styles.offerPrice}>{price}</p>}
      </div>
      {unitPrice && <p className={styles.offerUnitPrice}>{unitPrice}</p>}
      {description && <p className={styles.offerDescription}>{description}</p>}
      {subdescription && (
        <p className={styles.offerSubdescription}>{subdescription}</p>
      )}
      {timerSeconds != null && remaining > 0 && (
        <p className={styles.offerTimer}>
          {timerLabel} {formatTimer(remaining)}
        </p>
      )}
    </div>
  )
}

export default OfferBox
